import { Component, signal } from '@angular/core';
import { GeneralButtonComponent, MultiSelectComponent } from '../../components';
import { FormsModule } from '@angular/forms';
import type { IFilterAngularComp } from 'ag-grid-angular';
import type { IFilterParams } from 'ag-grid-community';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-ag-grid-multi-select.component',
  imports: [FormsModule, MultiSelectComponent, TranslatePipe, GeneralButtonComponent],
  templateUrl: './ag-grid-multi-select.component.html',
  styleUrl: './ag-grid-multi-select.component.scss',
})
export class AgGridMultiSelectComponent implements IFilterAngularComp {
  private params!: IFilterParams & { list: { id: number | string; name: string }[] };
  selectedIds: (number | string)[] = [];
  workingSelection = signal<Set<number | string>>(new Set());
  list: { id: number | string; name: string }[] = [];

  agInit(params: IFilterParams & { list: { id: number | string; name: string }[] }): void {
    this.params = params;
    this.list = params.list || [];
    this.workingSelection.set(new Set(this.list.map((u) => u.id)));
  }

  isFilterActive(): boolean {
    return this.selectedIds.length > 0;
  }

  getModel() {
    return this.selectedIds.length ? { values: this.selectedIds } : null;
  }

  setModel(model: { values: (number | string)[] }): void {
    this.selectedIds = model?.values ?? [];
    if (this.selectedIds.length > 0) {
      this.workingSelection.set(new Set([...this.selectedIds]));
    } else {
      this.workingSelection.set(new Set(this.list.map((u) => u.id)));
    }
  }

  onSelectionChanged(list: { id: number | string; name: string }[]): void {
    this.workingSelection.set(new Set(list.map((u) => u.id)));
  }

  doesFilterPass(): boolean {
    return false;
  }

  applyFilter(): void {
    this.selectedIds = [...this.workingSelection()];
    this.params.filterChangedCallback();
    this.params.api?.hidePopupMenu();
  }

  resetFilter(): void {
    this.selectedIds = [];
    this.workingSelection.set(new Set(this.list.map((u) => u.id)));
    this.params.filterChangedCallback();
  }
}
